"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const next_components_shared_article_1 = __importDefault(require("@motorata/next.components.shared.article"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const next_components_atoms_link_1 = __importDefault(require("@motorata/next.components.atoms.link"));
const ArticlesSection = (_a) => {
    var { title = "Sprawdź nasze artykuły", label = "Blog", showTitle = true, buttonLink = "/", showButton = true, data } = _a, rest = __rest(_a, ["title", "label", "showTitle", "buttonLink", "showButton", "data"]);
    return (react_1.default.createElement(Wrapper, Object.assign({}, rest),
        showTitle && (react_1.default.createElement(base_ui_components_atoms_typography_1.Title, { center: true, label: label, elementType: "label" }, title)),
        react_1.default.createElement(Content, null,
            data[0] && react_1.default.createElement(next_components_shared_article_1.default, { slug: data[0].slug, title: data[0].title, image: data[0].images.medium, lead: data[0].blockLead, date: data[0].date, readingTime: data[0].readingTime }),
            react_1.default.createElement(base_ui_components_atoms__atoms_1.Box, null, data.slice(1, 4).map(article => (react_1.default.createElement(next_components_shared_article_1.default, { key: article.id, type: "row", slug: article.slug, title: article.title, image: article.images.medium, lead: article.blockLead, date: article.date, readingTime: article.readingTime }))))),
        showButton && (react_1.default.createElement(next_components_atoms_link_1.default, { href: buttonLink, margin: "0 auto", type: "third" }, "Zobacz wszystkie artyku\u0142y"))));
};
exports.default = ArticlesSection;
const Content = styled_components_1.default.div `
  display: grid;
  //max-width: 1500px;
  margin: 0 auto;
  grid-template-columns: 1fr 1.2fr;
  grid-gap: 2rem;
  margin-bottom: 2rem;

  > div:nth-child(2) {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;

    > div:nth-child(2) {
      > div:nth-child(3) {
        display: none;
      }
    }
  }
`;
const Wrapper = styled_components_1.default.div `
  ${base_ui_components_atoms__atoms_1.blockStyles};
  ${base_ui_components_atoms__atoms_1.common};
`;
//# sourceMappingURL=ArticlesSection.js.map